import { Box, Card, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Card)`
  display: flex;
  flex-direction: column;
  margin: ${(p) => p.theme.spacing(6, 'auto')};
  padding: ${(p) => p.theme.spacing(1.5)};
  width: fit-content;
  box-shadow: ${(p) => p.theme.shadows[6]};
  gap: ${(p) => p.theme.spacing(2)};
`;

export const Title = styled(Stack)`
  padding-left: ${(p) => p.theme.spacing(1)};
  font-weight: bold;
  align-items: center;
`;

export const Content = styled(Box)`
  width: 400px;
  background-color: ${(p) =>
    p.theme.palette.grey[p.theme.palette.mode === 'dark' ? 600 : 100]};
  border-radius: ${(p) => p.theme.spacing(0.5)};
  padding: ${(p) => p.theme.spacing(5, 1.5)};
`;
